// Footer.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import QrImg from '../assets/images/qr.svg';
import MenuImg from '../assets/images/menu.svg';

const Footer = () => {
  const navigate = useNavigate();  // React Router's navigation hook

  const handleMenuClick = () => {
    navigate('/'); 
  };
  const handleQRClick = () => {
    navigate('/kartu');  
  };
  return (
    <div className="footer-nav">
      <div className="nav-item menu" onClick={handleMenuClick}>
        <img src={MenuImg} className="logofooter" alt="Menu" />
        <span>Dashboard</span>
      </div>
      <div className="nav-item" onClick={handleQRClick}>
        <img src={QrImg} className="logofooter" alt="Camera" />
        <span>Buka QR</span>
      </div>
      
    </div>
  );
};

export default Footer;
